module.exports = __webpack_public_path__ + "static/media/ml-fp.9ee50ca6.png";